export default {
  produtoCSV: {},
  listaProdutos: [],
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    ncm: '',
    ncmSeq: '',
    produto: '',
    descricao: '',
    unidadeMedida: '',
    moeda: '',
    valorUnitario: '',
    quantidade: '',
    valorTotal: '',
    empresa: '',
    order: 'ID',
    direcao: '',
    codigoCliente: '',
    codigoTrust: '',
  },
  campos: {
    id: 'ID',
    ncm: 'NCM',
    ncmSeq: 'NCM_SEQ',
    produto: 'PRODUTO',
    descricao: 'DESCRICAO',
    unidadeMedida: 'UNIDADE_MEDIDA',
    moeda: 'MOEDA',
    valorUnitario: 'VALOR_UNITARIO',
    quantidade: 'QUANTIDADE',
    valorTotal: '"valorTotal"',
    empresa: 'NOME_CLIENTE',
    codigoCliente: 'CODIGO_CLIENTE',
    coditoTrust: 'CODIGO_TRUST',
  },
  colDefault: 'ID',
  directionDefault: '',
  perPageSelect: [
    { text: '10', value: 10 },
    { text: '20', value: 20 },
    { text: '50', value: 50 },
    { text: '100', value: 100 },
  ],
};
